<template>
    <div class="workspace" ref="workspace">
        <workspace-area @openTemplateGroupManager="$emit('openTemplateGroupManager')"/>
    </div>
</template>

<script type="text/babel">
import Area from './Area/WorkspaceArea.vue';

export default {
    name: 'Workspace',
    components: {
        WorkspaceArea: Area
    }
    
};

</script>

<style lang="scss">
    @import "../../../../styles/templates/layer.scss";
    .workspace {
        height: calc(100vh - 80px);
    }
</style>
